module Client.Services

open Fetch.Types
open Thoth.Fetch
open Thoth.Json
open Fable.Core
open Fable.Core.JsInterop
open Thoth.Fetch.Helper

let myExtraCoders =
    Extra.empty
    |> Extra.withInt64
    |> Extra.withDecimal

let inline encoder<'T> = Encode.Auto.generateEncoderCached<'T>(extra = myExtraCoders)
let inline decoder<'T> = Decode.Auto.generateDecoderCached<'T>(extra = myExtraCoders)

let mutable accessTokenFunction = (fun () -> promise { return ""})
let getAuthHeader () =
  accessTokenFunction()
  |> Promise.map ((sprintf "Bearer %s") >> HttpRequestHeaders.Authorization)